import { useStepperContext } from "app/contexts/stepper";
import { useInscripcionContext } from "../../inscripcion-context";
import {
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  FormGroup,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { toast } from "react-hot-toast";
import { useState } from "react";

const initialState = {
  exportacion_detalles: "",
  exportacion_principal: false,
};

function ExportacionesForm({ exportacion = initialState }) {
  const { addExportacion, updateExportacion, deleteExportacion } =
    useInscripcionContext();

  const [state, setState] = useState(exportacion);
  const [isEditable] = useState(!!exportacion.exportacion_id);
  const [isEditing, setEditing] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();

    try {
      if (!!isEditable && !isEditing) {
        return setEditing(true);
      } else if (!!isEditable && !!isEditing) {
        const isUpdated = updateExportacion({
          exportacion: state,
        });

        if (isUpdated) {
          setEditing(false);

          return toast.success("¡Exportación actualizada!");
        }
      } else {
        const isAdded = addExportacion({ exportacion: state });

        if (isAdded) {
          setState(exportacion);

          return toast.success("¡Exportación agregada!");
        }
      }
    } catch (error) {
      console.log(error.message);

      return toast.error(error.message);
    }
  }

  function handleReset() {
    if (!!isEditable && !isEditing) {
      const isDeleted = deleteExportacion({
        exportacion_id: exportacion.exportacion_id,
      });

      if (isDeleted) {
        return toast.success("¡Exportación eliminada!");
      }
    } else if (!!isEditable && !!isEditing) {
      const isCanceled = window.confirm("¿Desea cancelar la edición?");

      if (isCanceled) {
        setState(exportacion);

        return setEditing(false);
      }
    } else {
      const isReseted = window.confirm("¿Desea reiniciar el formulario?");

      if (isReseted) {
        setState(exportacion);
      }
    }
  }

  return (
    <Paper
      component="form"
      className="animate__animated animate__slideInUp"
      onSubmit={handleSubmit}
      onReset={handleReset}
      variant="outlined"
    >
      <Grid container spacing={1} sx={{ padding: 2 }}>
        <Grid item xs={12}>
          <Typography variant="overline">
            <strong>{`${
              !!isEditable ? "Editar" : "Agregar"
            } exportación`}</strong>
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <TextField
            type="text"
            label="Exportación"
            value={state.exportacion_detalles}
            onChange={(e) =>
              setState((state) => ({
                ...state,
                exportacion_detalles: e.target.value,
              }))
            }
            size="small"
            fullWidth
            required
            disabled={!!isEditable && !isEditing}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormGroup>
            <FormControlLabel
              disabled={!!isEditable && !isEditing}
              control={
                <Checkbox
                  checked={state.exportacion_principal}
                  onChange={(e) =>
                    setState((state) => ({
                      ...state,
                      exportacion_principal: e.target.checked,
                    }))
                  }
                />
              }
              label="¿Es una importación principal?"
            />
          </FormGroup>
        </Grid>

        <Grid item xs={12} md={6}>
          <Stack direction="row" justifyContent="end" spacing={1}>
            <Button
              type="submit"
              variant="contained"
              size="small"
              color={!!isEditable ? "warning" : "success"}
            >
              {!!isEditable && !isEditing
                ? "Editar"
                : !!isEditing
                ? "Actualizar"
                : "Agregar"}
            </Button>

            <Button
              type="reset"
              variant="outlined"
              size="small"
              color={!!isEditable && !isEditing ? "error" : "inherit"}
            >
              {!!isEditable && !isEditing
                ? "Eliminar"
                : !!isEditing
                ? "Cancelar"
                : "Reiniciar"}
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
}

export function Exportaciones() {
  const stepper = useStepperContext();
  const { empresa } = useInscripcionContext();

  function handleNext() {
    try {
      if (!empresa.exportaciones.length) {
        // throw new Error(
        //   "¡Por favor, agregue al menos una exportaciones!"
        // );
      }

      return stepper.next();
    } catch (error) {
      return toast.error(error.message);
    }
  }

  return (
    <Stack spacing={2}>
      <Container maxWidth="sm">
        <Stack spacing={2}>
          {empresa.exportaciones.map((exportacion) => (
            <ExportacionesForm
              key={exportacion.exportacion_id}
              exportacion={exportacion}
            />
          ))}

          <ExportacionesForm />
        </Stack>
      </Container>

      <Stack
        direction="row"
        justifyContent="end"
        alignItems="center"
        spacing={1}
      >
        {!stepper.isFirstStep && (
          <Button variant="outlined" size="small" onClick={stepper.back}>
            Atrás
          </Button>
        )}

        <Button variant="contained" size="small" onClick={handleNext}>
          Siguiente
        </Button>
      </Stack>
    </Stack>
  );
}
